import { useCallback } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { AUTOMATIC_SUPPORTED_UNITS } from '@schuettflix/interfaces';
import { AutomaticProductsFormValues } from '../schema/getAutomaticProductsFormSchema.ts';
import { isTransportProduct } from '@/shared/domain/product/isTransportProduct.ts';
import { deriveQuantity } from '../utils/deriveQuantity.ts';

export function useSharedFormQuantities(methods: UseFormReturn<AutomaticProductsFormValues>) {
    const { getValues, setValue } = methods;

    const onPurchaseMaterialUnitChange = useCallback(
        (purchaseMaterialUnit?: AUTOMATIC_SUPPORTED_UNITS) => {
            if (!purchaseMaterialUnit) {
                return;
            }
            const [salesMaterialQuantity, salesMaterialUnit, vehicleClass] = getValues([
                'salesMaterialQuantity',
                'salesMaterialUnit',
                'vehicleClass',
            ]);

            if (salesMaterialQuantity !== undefined && salesMaterialUnit && vehicleClass) {
                setValue(
                    'purchaseMaterialQuantity',
                    deriveQuantity(
                        salesMaterialQuantity,
                        salesMaterialUnit,
                        purchaseMaterialUnit,
                        vehicleClass.payloadInTons
                    )
                );
            }
        },
        [getValues, setValue]
    );

    const onPurchaseTransportUnitChange = useCallback(
        (purchaseTransportUnit?: AUTOMATIC_SUPPORTED_UNITS) => {
            if (!purchaseTransportUnit) {
                return;
            }
            const [
                productType,
                salesMaterialQuantity,
                salesMaterialUnit,
                salesTransportQuantity,
                salesTransportUnit,
                vehicleClass,
            ] = getValues([
                'productType',
                'salesMaterialQuantity',
                'salesMaterialUnit',
                'salesTransportQuantity',
                'salesTransportUnit',
                'vehicleClass',
            ]);
            if (!vehicleClass) {
                return;
            }

            if (isTransportProduct(productType)) {
                if (salesTransportQuantity !== undefined && salesTransportUnit) {
                    setValue(
                        'purchaseTransportQuantity',
                        deriveQuantity(
                            salesTransportQuantity,
                            salesTransportUnit,
                            purchaseTransportUnit,
                            vehicleClass.payloadInTons
                        )
                    );
                }
            } else {
                if (salesMaterialQuantity !== undefined && salesMaterialUnit) {
                    setValue(
                        'purchaseTransportQuantity',
                        deriveQuantity(
                            salesMaterialQuantity,
                            salesMaterialUnit,
                            purchaseTransportUnit,
                            vehicleClass.payloadInTons
                        )
                    );
                }
            }
        },
        [getValues, setValue]
    );

    return { onPurchaseMaterialUnitChange, onPurchaseTransportUnitChange };
}
